import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PostPropertyComponent } from './post-property/post-property.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularEditorModule } from '@kolkov/angular-editor';

import { UtilityModule } from '../utility/utility.module';

import { CustomerLoginComponent } from './customer-login/customer-login.component';
import { AgentsLoginComponent } from './agents-login/agents-login.component';
import { BuildersLoginComponent } from './builders-login/builders-login.component';
import { ServiceProvidersLoginComponent } from './service-providers-login/service-providers-login.component';
import { LoginModalComponent } from './login-modal/login-modal.component';
import { PostPropertyAlertComponent } from './post-property-alert/post-property-alert.component';
import { ServiceProviderListViewComponent } from './service-provider-list-view/service-provider-list-view.component';
import { AgentNetworkPostListComponent } from './agent-network-post-list/agent-network-post-list.component';
import { BuilderNetworkProfileListComponent } from './builder-network-profile-list/builder-network-profile-list.component';
import { UserNetworkPostListComponent } from './user-network-post-list/user-network-post-list.component';
import { VenturesComponent } from './ventures/ventures.component';
import { PropertyVentureViewComponent } from './property-venture-view/property-venture-view.component';
import { PropertyInfoModalComponent } from './property-info-modal/property-info-modal.component';
import { GetUserAppoinmentComponent } from './get-user-appoinment/get-user-appoinment.component';


@NgModule({
  declarations: [
    PostPropertyComponent,
    CustomerLoginComponent,
    AgentsLoginComponent,
    BuildersLoginComponent,
    ServiceProvidersLoginComponent,
    LoginModalComponent,
    PostPropertyAlertComponent,
    ServiceProviderListViewComponent,
    AgentNetworkPostListComponent,
    BuilderNetworkProfileListComponent,
    UserNetworkPostListComponent,
    VenturesComponent,
    PropertyVentureViewComponent,
    PropertyInfoModalComponent,
    GetUserAppoinmentComponent
  ],
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, AngularEditorModule, UtilityModule
  ],
  exports: [PostPropertyComponent, CustomerLoginComponent, AgentsLoginComponent, 
    BuildersLoginComponent, ServiceProvidersLoginComponent, LoginModalComponent,
    PostPropertyAlertComponent, ServiceProviderListViewComponent, AgentNetworkPostListComponent,
    BuilderNetworkProfileListComponent, UserNetworkPostListComponent, VenturesComponent, 
    PropertyVentureViewComponent, PropertyInfoModalComponent, GetUserAppoinmentComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],  
})
export class WidgetsModule { }
